import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  ReferenceField,
  EditButton,
  DeleteButton,
  CreateButton,
  TopToolbar,
  BooleanField,
  useRecordContext,
} from 'react-admin';
import { Chip } from '@mui/material';
import { createEmptyStateComponent } from '../../components/createEmptyStateComponent';
import { PageWrapper } from '../../components/PageWrapper';

const EmploymentStatusField = () => {
  const record = useRecordContext();
  if (record?.current === undefined) return null;
  
  return (
    <Chip 
      label={record.current ? 'Current' : 'Previous'} 
      color={record.current ? 'success' : 'default'}
      size="small"
    />
  );
};

const ContactField = () => {
  const record = useRecordContext();
  if (!record?.contactHas) return <span>No</span>;
  
  return (
    <Chip 
      label="Available" 
      color="info"
      size="small"
    />
  );
};

const ListActions = () => (
  <TopToolbar>
    <CreateButton />
  </TopToolbar>
);

const DriverEmploymentEmptyState = createEmptyStateComponent('driver-employment');

export const DriverEmploymentList = () => (
  <PageWrapper title="Driver Employment">
    <List
      perPage={25}
      sort={{ field: 'id', order: 'DESC' }}
      actions={<ListActions />}
      empty={<DriverEmploymentEmptyState />}
    >
      <Datagrid>
        <TextField source="id" />
        <ReferenceField source="driverId" reference="drivers" link="show">
          <ReferenceField source="userId" reference="users" link={false}>
            <TextField source="name" />
          </ReferenceField>
        </ReferenceField>
        <TextField source="company" />
        <TextField source="title" />
        <DateField source="startDate" />
        <DateField source="endDate" />
        <EmploymentStatusField />
        <TextField source="city" />
        <TextField source="regionCode" label="Province" />
        <ContactField />
        <DateField source="createdAt" />
        <EditButton />
        <DeleteButton />
      </Datagrid>
    </List>
  </PageWrapper>
);